import React, { useState, useEffect } from 'react'
import GenericTable from '../GenericTable/table'
import RadioButtons from '../GenericTable/radio_buttons'
import Card from '../CardWidgets/Card'
import DatePicker from '../GenericTable/CommonDatePicker'
import {
  enterprises,
  fetchEnterprisesData,
  farmersData,
  fetchFarmersData,
  farmsData,
  fetchFarmsData,
} from './helper'
import {updateFarmer, updateEnterprise, activateUser, deactivateUser} from '../../../api'
import EnterpriseModal from '../EnterpriseForm/EnterpriseModal'
import FarmerModal from '../FarmerForm/FarmerModal'
import Swal from 'sweetalert2'
import SkeletonCard from '../Auth/Components/SkeletonCard'
import { Tooltip } from 'react-tooltip'
import ApiEnterpriseName from './api_hits/ApiEnterpriseName'

// Contract management imports
import AmendContractModal from '../EnterpriseForm/AmendContractModal'
import RenewContractModal from '../EnterpriseForm/RenewContractModal'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileCirclePlus,
  faFilePen,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import ContractModal from '../EnterpriseForm/ContractModel'
import { useAuth } from '../Auth'


type SortConfig = { key: string; direction: 'asc' | 'desc' | null }

const CropMonitoring: React.FC = () => {
  const { currentUser } = useAuth()
  const canEditStatus = currentUser?.role === 'Admin' || currentUser?.role === 'Operations'
  const [columns, setColumns] = useState<string[]>([])
  const [data, setData] = useState<Record<string, any>[]>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const tabs = ['Enterprises', 'Farmers', 'Farms']
  const [activeTab, setActiveTab] = useState(tabs[0])
  // const [tab, setTab] = useState<'Farmers' | 'Farms' | 'Enterprises'>('Enterprises');
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [buttonLabel, setButtonLabel] = useState('Add Enterprise')
  const [filterType, setFilterType] = useState<string>('All')
  const [loading, setLoading] = useState<boolean>(true)
  const [selectedDays, setSelectedDays] = useState({
    startDate: '',
    endDate: '',
  })
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [currentPageData, setCurrentPageData] = useState<Record<string, any>[]>([])

  const [totalPages, setTotalPages] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  // const itemsPerPage = 10
  const [sortConfig, setSortConfig] = useState<SortConfig>({ key: '', direction: null })
  const [isCardVisible, setIsCardVisible] = useState(true)
  const [farmersDate, setFarmersDate] = useState(new Date())
  const [farmsDate, setFarmsDate] = useState(new Date())
  const [selectedEnterprise, setSelectedEnterprise] = useState<number | null>(null)

  // Contract management state
  const [isAmendModalOpen, setIsAmendModalOpen] = useState(false)
  const [isRenewModalOpen, setIsRenewModalOpen] = useState(false)
  const [selectedEnterpriseForContract, setSelectedEnterpriseForContract] = useState<{
    id: number
    name: string
    contractStartDate: string
    contractEndDate: string
    contractDurationMonths: number
  } | null | any>(null)

  const [showContractModal, setShowContractModal] = useState(false);
  const [contractMode, setContractMode] = useState<"add" | "edit" | "view">("add");
  const [selectedCompanyId, setSelectedCompanyId] = useState<number | null>(null);
  const [enterpriseName, setEnterpriseName] = useState<string | null>(null)

  const handleOpenModal = () => setIsModalOpen(true)
  const handleCloseModal = () => setIsModalOpen(false)

  const handleAddContract = (companyId: number, name: string) => {
    setContractMode("add");
    setSelectedCompanyId(companyId);
    setShowContractModal(true);
    setEnterpriseName(name)
  };

  const handleEditContract = (enterprise: any, name: string) => {
    setContractMode("edit");
    setSelectedCompanyId(enterprise);
    setShowContractModal(true);
    setEnterpriseName(name)
  };

  const handleCloseContractModal = () => {
    setShowContractModal(false);
    setSelectedCompanyId(null);
  };

  const handleViewContract = (companyId: number, name: string) => {
    setContractMode("view");
    setSelectedCompanyId(companyId);
    setShowContractModal(true);
    setEnterpriseName(name)
  };


  const columnKeyMapping: Record<string, string> = {
    "Farmer Id": "id",
    "Phone": "ph",
    "Email": "email",
    "Created Date": "created_at",
    "Last Logged In": "last_login",
    "Is Active": "is_active",
    "Suspended": "suspended",
    "Source": "source",
    "Company Id": "company_id",
    "Country": "country",
    "State": "state",
    "City": "city"
  };
  const columnKeyMappingFarms: Record<string, string> = {
    "Farm Id": 'id',
    'Farm Name': 'name',
    'Farmer Id': 'user_id',
    'Farmer Name': 'farmer_name',
    'Email': 'email',
    'Area (ac)': 'area',
    'Country': 'country',
    'State': 'state',
    'Company Id': 'company_id',
    'Is Paid': 'is_paid',
    'Created At': 'created_at',
    'Expiry Date': 'expiry_date',
    'Region': 'region',
  };


  // const handleTabClick = async (tab: string) => {
  const fetchData = async (page) => {
    setLoading(true);
    let rawData: Record<string, any>[] = [];
    let rawColumns: string[] = [];
    if ((activeTab === 'Farmers' || activeTab === 'Farms') && (!selectedDays.startDate || !selectedDays.endDate)) {
      setLoading(false);
      return;
    }

    switch (activeTab) {
      case 'Farmers':
        rawColumns = farmersData.columns;
        try {
          const sortKey = sortConfig.key ? columnKeyMapping[sortConfig.key] : 'created_at';
          const sortOrder = sortConfig.direction !== null ? sortConfig.direction : 'desc';

          const response = await fetchFarmersData(selectedDays.startDate, selectedDays.endDate, page, sortKey, sortOrder, searchTerm);
          console.log(response, "response from farmers table");
          rawData = response.farmers;

          setCurrentPage(response.currentPage || page);
          setTotalPages(Math.ceil(response.totalPages));
          setCurrentPageData(response.farmers)
          setSearchTerm(searchTerm)
          console.log("response")
        } catch (error) {
          console.error('Error fetching farmers data:', error);
          rawData = [];
        }
        setButtonLabel('Add Farmer');
        break;


      case 'Farms':
        rawColumns = farmsData.columns;
        try {
          const enterpriseId = selectedEnterprise !== null ? selectedEnterprise.toString() : undefined;
          const sortKey = sortConfig.key ? columnKeyMappingFarms[sortConfig.key] : 'created_at';
          const sortOrder = sortConfig.direction ?? 'desc';
          const response = await fetchFarmsData(
            selectedDays.startDate,
            selectedDays.endDate,
            currentPage,
            sortKey,
            sortOrder,
            enterpriseId
          );

          rawData = response.farmsData;
          setCurrentPage(response.currentPage || page);
          setTotalPages(Math.ceil(response.totalPages));
          setCurrentPageData(response.farmsData);
        } catch (error) {
          console.error('Error fetching farms data:', error);
          rawData = [];
        }
        break;


      case 'Enterprises':
        rawColumns = enterprises.columns;
        try {
          const response = await fetchEnterprisesData();
          rawData = response;
          setCurrentPage(1);
          setFilterType('All');
          setSearchTerm('');
        } catch (error) {
          console.error('Error fetching enterprises data:', error);
          rawData = [];
        }
        setButtonLabel('Add Enterprise');
        break;

      default:
        break;
    }

    const mappedData = mapDataToColumns(rawData, rawColumns);
    setColumns(rawColumns);
    setData(mappedData);
    if (activeTab === 'Farmers' || activeTab === 'Farms') {
      setCurrentPageData(mappedData);
    }
    else {
      setTotalPages(Math.ceil(mappedData.length / pageSize));
      setCurrentPageData(mappedData);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (activeTab === 'Farms') {
      setSelectedEnterprise(null)
    }
  }, [activeTab])

  const dependencies = ['Farmers', 'Farms'].includes(activeTab)
    ? [selectedDays, activeTab, currentPage, sortConfig, ...(activeTab === 'Farms' ? [selectedEnterprise] : [])]
    : [selectedDays, activeTab];


  useEffect(() => {
    fetchData(currentPage);
  }, dependencies);



  const sortData = (data: Record<string, any>[], column: string) => {
    const sortableData = [...data]
    sortableData.sort((a, b) => {
      const aValue = a[column]
      const bValue = b[column]
      if (column === 'Farmer Id') {
        const aNumber = parseFloat(aValue)
        const bNumber = parseFloat(bValue)
        if (!isNaN(aNumber) && !isNaN(bNumber)) {
          return sortConfig.direction === 'asc' ? aNumber - bNumber : bNumber - aNumber
        }
      }
      if (column === 'Enterprise Id') {
        const aNumber = parseFloat(aValue)
        const bNumber = parseFloat(bValue)
        if (!isNaN(aNumber) && !isNaN(bNumber)) {
          return sortConfig.direction === 'asc' ? aNumber - bNumber : bNumber - aNumber
        }
      }
      if (column === 'Company Id') {
        const aNumber = parseFloat(aValue)
        const bNumber = parseFloat(bValue)
        if (!isNaN(aNumber) && !isNaN(bNumber)) {
          return sortConfig.direction === 'asc' ? aNumber - bNumber : bNumber - aNumber
        }
      }
      if (column === 'Area (ha)' || 'Total Area (ha)') {
        const aNumber = parseFloat(aValue)
        const bNumber = parseFloat(bValue)
        if (!isNaN(aNumber) && !isNaN(bNumber)) {
          return sortConfig.direction === 'asc' ? aNumber - bNumber : bNumber - aNumber
        }
      }
      if (column === 'Farm Id' || (typeof aValue === 'string' && typeof bValue === 'string')) {
        // Check if values are hexadecimal strings
        const isHexA = /^[a-fA-F0-9]+$/.test(aValue)
        const isHexB = /^[a-fA-F0-9]+$/.test(bValue)

        if (isHexA && isHexB) {
          return sortConfig.direction === 'asc'
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue)
        }

        // General string comparison
        return sortConfig.direction === 'asc'
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue)
      }

      // Check if the column is a date column and parse it
      const aDate = Date.parse(aValue)
      const bDate = Date.parse(bValue)
      if (!isNaN(aDate) && !isNaN(bDate)) {
        return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate
      }

      if (!isNaN(aValue) && !isNaN(bValue)) {
        return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue
      }

      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue
      }

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return sortConfig.direction === 'asc'
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue)
      }

      return 0
    })

    return sortableData
  }

  const handleSort = (column: string) => {
    setSortConfig((prevConfig) => {
      const direction = prevConfig.key === column && prevConfig.direction === 'asc' ? 'desc' : 'asc';
      return { key: column, direction };
    });
  };

  useEffect(() => {
    if (sortConfig.key) {
      const sortedData = sortData(data, sortConfig.key);
      setData(sortedData);
    }
  }, [sortConfig]);

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1)
    }
  }

  const handlePreviousClick = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1)
    }
  }

  const mapDataToColumns = (
    data: Record<string, any>[],
    columns: string[]
  ): Record<string, any>[] => {
    if (!data || !Array.isArray(data)) {
      console.warn('mapDataToColumns received invalid data:', data)
      return []
    }

    return data.map((row) => {
      const mappedRow: Record<string, any> = {}
      columns.forEach((col) => {
        const key = col.replace(/\s+/g, '')
        mappedRow[col] = row[key] || ''
      })

      // Preserve raw contract fields for modal use
      mappedRow['_contractStartRaw'] = row['_contractStartRaw'] || ''
      mappedRow['_contractEndRaw'] = row['_contractEndRaw'] || ''
      mappedRow['_contractDurationMonths'] = row['ContractDurationMonths'] || 0

      return mappedRow
    })
  }

  // Handle dropdown selection
  const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrentPage(1)
    setFilterType(e.target.value)
  }

  // Handle enterprise selection
  const handleEnterpriseChange = (enterpriseId: number | null) => {
    setSelectedEnterprise(enterpriseId)
    setCurrentPage(1) // Reset to first page when changing enterprise filter
  }

  const handleSearch = () => {
    if (activeTab === 'Farmers') {
      if (searchTerm.trim() === '') {
        // If search input is empty, reload all farmer data
        fetchData(1);
      } else {
        fetchData(1);
      }
    }
  };
  const handleFarmerStatus = (farmerId: number, newStatus: string) => {
    const selectedRow = data.find((row) => row['Farmer Id'] === farmerId)
    if (!selectedRow) {
      Swal.fire('Error', 'Farm not found.', 'error')
      return
    }
    Swal.fire({
      title: 'Are you sure you want to change the status?',
      // text: Are you sure you want to ${newStatus} selected farmer?,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        setData((prevData) =>
          prevData.map((row, index) =>
            row['Farmer Id'] === farmerId ? { ...row, 'Is Active': newStatus } : row
          )
        )
        const isActive = newStatus === 'Active'
        updateFarmer({ farmer_id: farmerId, is_active: isActive })
          .then(() => {
            Swal.fire('Updated!', `Status has been changed to ${newStatus}`, 'success')
          })
          .catch((error) => {
            const errorMessage =
              error.response?.data?.message || 'Something went wrong , please try again.'
            Swal.fire('Error', errorMessage, 'error')
          })
      }
    })
  }

  const handleFarmerSuspend = (farmerId: number, newStatus: string) => {
    const selectedRow = data.find((row) => row['Farmer Id'] === farmerId)
    if (!selectedRow) {
      Swal.fire('Error', 'Farm not found.', 'error')
      return
    }
    const previousStatus = selectedRow['Suspended']
    const suspend = newStatus === 'Suspend'
    Swal.fire({
      title: 'Are you sure you want to change the status?',
      input: 'textarea',
      inputLabel: 'Reason',
      inputPlaceholder: `Enter a reason for marking this farmer as ${newStatus}`,
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return 'A reason is required.'
        }
        return undefined
      },
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        const reason = result.value.trim()
        setData((prevData) =>
          prevData.map((row, index) =>
            row['Farmer Id'] === farmerId ? {...row, 'Suspended': newStatus} : row
          )
        )
        const request = suspend ? deactivateUser(farmerId, reason) : activateUser(farmerId, reason)
        request
          .then(() => {
            Swal.fire('Updated!', `Status has been changed to ${newStatus}`, 'success')
          })
          .catch((error) => {
            setData((prevData) =>
              prevData.map((row, index) =>
                row['Farmer Id'] === farmerId ? {...row, 'Suspended': previousStatus} : row
              )
            )
            const errorMessage =
              error.response?.data?.message || 'Something went wrong , please try again.'
            Swal.fire('Error', errorMessage, 'error')
          })
      }
    })
  }

  const handleEnterpriseStatus = (companyId: number, newStatus: string) => {
    const selectedRow = data.find((row) => row['Enterprise Id'] === companyId)
    if (!selectedRow) {
      Swal.fire('Error', 'Farm not found.', 'error')
      return
    }
    Swal.fire({
      title: `Are you sure you want to change the status?`,
      // text: `Are you sure you want to ${newStatus} selected enterprise?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        setData((prevData) =>
          prevData.map((row, index) =>
            row['Enterprise Id'] === companyId ? { ...row, 'Is Active': newStatus } : row
          )
        )
        const isActive = newStatus === 'Active'
        updateEnterprise({ company_id: companyId, is_active: isActive })
          .then(() => {
            Swal.fire('Updated!', `Status has been changed to ${newStatus}.`, 'success')
          })
          .catch((error) => {
            const errorMessage =
              error.response?.data?.message || 'Something went wrong , please try again.'
            Swal.fire('Error', errorMessage, 'error')
          })
      }
    })
  }

  const handleEnterpriseSuspend = (companyId: number, newStatus: string) => {
    const selectedRow = data.find((row) => row['Enterprise Id'] === companyId)
    if (!selectedRow) {
      Swal.fire('Error', 'Enterprise not found.', 'error')
      return
    }
    const previousStatus = selectedRow['Suspended']
    Swal.fire({
      title: 'Are you sure you want to change the status?',
      input: 'textarea',
      inputLabel: 'Reason',
      inputPlaceholder: `Enter a reason for marking this enterprise as ${newStatus}`,
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return 'A reason is required.'
        }
        return undefined
      },
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        const reason = result.value.trim()
        setData((prevData) =>
          prevData.map((row, index) =>
            row['Enterprise Id'] === companyId ? {...row, 'Suspended': newStatus} : row
          )
        )
        const suspend = newStatus === 'Suspend'
        const request = suspend
          ? deactivateUser(companyId, reason, 'enterprise')
          : activateUser(companyId, reason, 'enterprise')
        request
          .then(() => {
            Swal.fire('Updated!', `Status has been changed to ${newStatus}`, 'success')
          })
          .catch((error) => {
            setData((prevData) =>
              prevData.map((row, index) =>
                row['Enterprise Id'] === companyId ? {...row, 'Suspended': previousStatus} : row
              )
            )
            const errorMessage =
              error.response?.data?.message || 'Something went wrong , please try again.'
            Swal.fire('Error', errorMessage, 'error')
          })
      }
    })
  }

  useEffect(() => {
    const filteredData = data.filter((row) => {
      console.log(row, "row Data");

      // Search filter
      const matchesSearch = Object.values(row)
        .join(' ')
        .toLowerCase()
        .includes(searchTerm.toLowerCase());

      // Source filter
      const matchesFilter =
        filterType === 'All' ||
        (filterType === 'Web' && row.Source?.toLowerCase() === 'web') ||
        (filterType === 'Mobile' && row.Source?.toLowerCase() === 'mobile');
      // Enterprise filter for Farms tab
      const matchesEnterprise =
        activeTab !== 'Farms' ||
        selectedEnterprise === null ||
        String(row['Company Id']) === String(selectedEnterprise);
      return matchesSearch && matchesFilter && matchesEnterprise;
    });
    if (activeTab !== 'Farmers' && activeTab !== 'Farms') {
      setTotalPages(Math.ceil(filteredData.length / pageSize));
    }


    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const currentPageData = filteredData.slice(startIndex, endIndex);


    if (activeTab === 'Farmers' || activeTab === 'Farms') {
      setCurrentPageData(filteredData)
    }
    else {
      setCurrentPageData(currentPageData);
    }
  }, [data, currentPage, searchTerm, filterType, activeTab, pageSize, selectedEnterprise, activeTab]);

  return (
    <>
      <div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button
            style={{
              position: 'relative',
              padding: '5px',
              backgroundColor: 'white',
              border: '1px solid #6D9300',
              borderRadius: '10px',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={() => setIsCardVisible((prev) => !prev)}
          >
            {isCardVisible ? (
              <i className='ki-solid ki-double-up fs-1' style={{ color: '#6D9300', margin: '0' }}></i>
            ) : (
              <i
                className='ki-solid ki-double-down fs-1'
                style={{ color: '#6D9300', margin: '0' }}
              ></i>
            )}
          </button>
        </div>

        {/* Conditionally render Card */}
        {isCardVisible && <Card type={'All'} />}
      </div>
      <div className='card card-flush mb-6 mb-xl-9 mt-2'>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
          <RadioButtons tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            {(activeTab === 'Farmers' || activeTab === 'Farms') && (
              <>
                {activeTab === 'Farms' && (
                  <ApiEnterpriseName
                    selectedEnterprise={selectedEnterprise}
                    setSelectedEnterprise={handleEnterpriseChange}
                  />
                )}

                {activeTab === 'Farmers' && (
                  <div>
                    <select
                      className='form-select form-select-solid w-100px'
                      data-control='select2'
                      data-placeholder='Select an option'
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        width: '100%',
                        margin: '16px',
                      }}
                      value={filterType}
                      onChange={handleFilterChange}
                    >
                      <option value='All'>All</option>
                      <option value='Web'>Web</option>
                      <option value='Mobile'>Mobile</option>
                    </select>
                  </div>
                )}

                <DatePicker setSelectedDays={setSelectedDays} activeTab={activeTab} />
              </>
            )}

          </div>
        </div>

        {buttonLabel === 'Add Enterprise' ? (
          <EnterpriseModal isOpen={isModalOpen} onClose={handleCloseModal} />
        ) : (
          <FarmerModal isOpen={isModalOpen} onClose={handleCloseModal} />
        )}

        {/* Contract Modals */}
        {selectedEnterpriseForContract && (
          <AmendContractModal
            isOpen={isAmendModalOpen}
            onClose={() => {
              setIsAmendModalOpen(false)
              setSelectedEnterpriseForContract(null)
            }}
            onSuccess={() => fetchData(currentPage)}   // ← add
            enterpriseId={selectedEnterpriseForContract.id}
            enterpriseName={selectedEnterpriseForContract.name}
            currentContractStartDate={selectedEnterpriseForContract.contractStartDate}
            currentContractDurationMonths={selectedEnterpriseForContract.contractDurationMonths}
          />
        )}
        {selectedEnterpriseForContract && (
          <RenewContractModal
            isOpen={isRenewModalOpen}
            onClose={() => {
              setIsRenewModalOpen(false)
              setSelectedEnterpriseForContract(null)
            }}
            onSuccess={() => fetchData(currentPage)}   // ← add
            enterpriseId={selectedEnterpriseForContract.id}
            enterpriseName={selectedEnterpriseForContract.name}
            currentContractEndDate={selectedEnterpriseForContract.contractEndDate}
          />
        )}

        {showContractModal && (
          <ContractModal
            isOpen={showContractModal}
            onClose={handleCloseContractModal}
            mode={contractMode}
            companyId={selectedCompanyId}
            onSuccess={() => fetchData(currentPage)}
            enterpriseName={enterpriseName}
          />
        )}

        {loading ? (
          <SkeletonCard />
        ) : (
          <>
            <GenericTable
              columns={columns}
              handleNextClick={handleNextClick}
              handlePriviousClick={handlePreviousClick}
              data={currentPageData}
              searchTerm={searchTerm}
              handleSort={handleSort}
              sortConfig={sortConfig}
              onSearch={(searchTerm) => {
                setSearchTerm(searchTerm)
                setCurrentPage(1)
              }}
              buttonConfig={
                activeTab !== 'Farms'
                  ? {
                    label: buttonLabel,
                    onClick: handleOpenModal,
                  }
                  : undefined
              }
              // totalPages = {totalPages}
              renderCell={(column, row, rowIndex) => {
                if (buttonLabel === 'Add Farmer' && column === 'Is Active') {
                  return (
                    <select
                      className='form-select form-select-solid'
                      value={row[column]}
                      onChange={(e) => handleFarmerStatus(row['Farmer Id'], e.target.value)}
                      style={{ width: 'auto' }}
                    >
                      <option value='Inactive'>Inactive</option>
                      <option value='Active'>Active</option>
                    </select>
                  )
                }
                if (buttonLabel === 'Add Farmer' && column === 'Suspended') {
                  if (!canEditStatus) {
                    return <span>{row[column]}</span>
                  }
                  return (
                    <select
                      className='form-select form-select-solid'
                      value={row[column]}
                      onChange={(e) => handleFarmerSuspend(row['Farmer Id'], e.target.value)}
                      style={{width: 'auto'}}
                    >
                      <option value='Unsuspend'>Unsuspend</option>
                      <option value='Suspend'>Suspend</option>
                    </select>
                  )
                }
                if (buttonLabel === 'Add Enterprise' && column === 'Is Active') {
                  return (
                    <select
                      className='form-select form-select-solid'
                      value={row[column]}
                      onChange={(e) => handleEnterpriseStatus(row['Enterprise Id'], e.target.value)}
                      style={{ width: 'auto' }}
                    >
                      <option value='Inactive'>Inactive</option>
                      <option value='Active'>Active</option>
                    </select>
                  )
                }
                if (buttonLabel === 'Add Enterprise' && column === 'Suspended') {
                  if (!canEditStatus) {
                    return <span>{row[column]}</span>
                  }
                  return (
                    <select
                      className='form-select form-select-solid'
                      value={row[column]}
                      onChange={(e) => handleEnterpriseSuspend(row['Enterprise Id'], e.target.value)}
                      style={{width: 'auto'}}
                    >
                      <option value='Unsuspend'>Unsuspend</option>
                      <option value='Suspend'>Suspend</option>
                    </select>
                  )
                }

                if (buttonLabel === '' && column === 'Center') {
                  const centerUrl = row[column]
                  return centerUrl ? (
                    <a href={centerUrl} target='_blank' rel='noopener noreferrer'>
                      {centerUrl}
                    </a>
                  ) : (
                    <span>No URL available</span>
                  )
                }
                if (column === 'Farm Name') {
                  const text = row[column] || "";
                  const maxLength = 20;
                  const truncatedText = text.length > maxLength ? text.slice(0, maxLength) + "..." : text;

                  return (
                    <>
                      <span data-tooltip-id="comment-tooltip" data-tooltip-content={text}>
                        {truncatedText}
                      </span>
                      <Tooltip id="comment-tooltip"
                        place="bottom" // Tooltip position: top, bottom, left, right
                        style={{ backgroundColor: "#6D9300", color: "#fff", padding: "4px", borderRadius: "6px" }} />
                    </>
                  );
                }

                if (activeTab === 'Enterprises' && column === 'Contract Status') {
                  const status = row[column]
                  const isExpired = status?.toLowerCase() === 'expired'
                  return (
                    <span className={`badge ${isExpired ? 'badge-light-danger' : 'badge-light-success'}`}>
                      {status || '-'}
                    </span>
                  )
                }

                if (activeTab === 'Enterprises' && column === 'Change Contract') {
                  return (
                    <div className='d-flex gap-2'>
                      <button
                        className='btn btn-sm'
                        style={{ backgroundColor: '#6D9300', color: 'white', padding: '4px 8px' }}
                        onClick={() => {
                          setSelectedEnterpriseForContract({
                            id: row['Enterprise Id'],
                            name: row['Enterprise Name'],
                            contractStartDate: row['_contractStartRaw'],        // ← raw date
                            contractEndDate: row['_contractEndRaw'],            // ← raw date
                            contractDurationMonths: row['_contractDurationMonths'], // ← raw number
                          })
                          setIsAmendModalOpen(true)
                        }}
                      >
                        Change
                      </button>
                    </div>
                  )
                }

                if (activeTab === 'Enterprises' && column === 'Renew Contract') {
                  return (
                    <div className='d-flex gap-2'>
                      <button
                        className='btn btn-sm'
                        style={{ backgroundColor: '#6D9300', color: 'white', padding: '4px 8px' }}
                        onClick={() => {
                          setSelectedEnterpriseForContract({
                            id: row['Enterprise Id'],
                            name: row['Enterprise Name'],
                            contractStartDate: row['_contractStartRaw'],        // ← raw date
                            contractEndDate: row['_contractEndRaw'],            // ← raw date
                            contractDurationMonths: row['_contractDurationMonths'],
                          })
                          setIsRenewModalOpen(true)
                        }}
                      >
                        Renew
                      </button>
                    </div>
                  )
                }

                if (activeTab === 'Farmers' && column === 'Contract Status') {
                  const status = row[column]
                  const isExpired = status?.toLowerCase() === 'expired'
                  return (
                    <span className={`badge ${isExpired ? 'badge-light-danger' : 'badge-light-success'}`}>
                      {status || '-'}
                    </span>
                  )
                }

                if (activeTab === "Enterprises" && column === "Contract") {
                  return (
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-sm btn-light-success"
                        onClick={() => handleAddContract(row["Enterprise Id"], row["Enterprise Name"])}
                      >
                        <FontAwesomeIcon icon={faFileCirclePlus} />
                      </button>

                      <button
                        className="btn btn-sm btn-light-primary"
                        onClick={() => handleEditContract(row["Enterprise Id"], row["Enterprise Name"])}
                      >
                        <FontAwesomeIcon icon={faFilePen} />
                      </button>

                      <button
                        className="btn btn-sm btn-light-info"
                        title="View Contract"
                        onClick={() => handleViewContract(row["Enterprise Id"], row["Enterprise Name"])}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>

                    </div>
                  );
                }
                return row[column]
              }}

              LeftSideElement={
                activeTab === 'Farmers' ? (
                  <button
                    type="button"
                    className="btn"
                    onClick={handleSearch}
                    style={{ backgroundColor: "#6D9300", color: 'white', padding: '7px 10px' }}
                  >
                    Search
                  </button>
                ) : undefined
              }
            />
            <ul className='pagination justify-content-center' style={{ margin: '15px 0' }}>
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button
                  className='page-link'
                  onClick={() => {
                    if (handlePreviousClick) handlePreviousClick()
                  }}
                  disabled={currentPage === 1}
                  aria-label='Previous'
                >
                  &laquo; Previous
                </button>
              </li>

              <li className='page-item active'>
                <div className='d-flex align-items-center'>
                  <button
                    className='page-link'
                    style={{ backgroundColor: '#6D9300', color: '#fff', pointerEvents: 'none' }}
                  >
                    {currentPage}
                  </button>
                  <span className='mx-2'>of</span>
                  <button
                    className='page-link'
                    style={{ backgroundColor: '#6D9300', color: '#fff', pointerEvents: 'none' }}
                  >
                    {totalPages}
                  </button>
                </div>
              </li>

              <li className={`page-item ${currentPage >= totalPages ? 'disabled' : ''}`}>
                <button
                  className='page-link'
                  onClick={() => {
                    if (handleNextClick) handleNextClick()
                  }}
                  disabled={currentPage >= totalPages}
                  aria-label='Next'
                >
                  Next &raquo;
                </button>
              </li>
            </ul>
          </>
        )}
      </div>
    </>
  )
}

export { CropMonitoring }
